import { supabase } from "./supabase";
import {
  isTrustedEntityGovernanceRow,
  normalizeEntityGovernanceRow,
  type TrustedEntityGovernanceRow
} from "./entityGovernanceRollup";

async function loadEntityGovernanceRows(
  accountId: string
): Promise<TrustedEntityGovernanceRow[]> {
  const { data, error } = await supabase
    .from("account_entity_roles")
    .select(
      "id, raw_entity_name, normalized_entity_name, parent_entity_name, entity_role, score_treatment, confidence_score, source, approved_at, review_status, is_active"
    )
    .eq("account_id", accountId)
    .eq("is_active", true)
    .limit(1000);

  if (error) {
    throw error;
  }

  return (data || [])
    .map(normalizeEntityGovernanceRow)
    .filter(
      (row) =>
        row.is_active &&
        (!row.review_status || row.review_status === "approved")
    );
}

export async function loadTrustedEntityGovernance(
  accountId: string
): Promise<TrustedEntityGovernanceRow[]> {
  const rows = await loadEntityGovernanceRows(accountId);
  return rows.filter(isTrustedEntityGovernanceRow);
}

/**
 * Manual review targets are visible independently of automatic resolution
 * confidence. The rollup still applies its trusted/automated eligibility gate.
 */
export async function loadEntityGovernanceReviewTargets(
  accountId: string
): Promise<TrustedEntityGovernanceRow[]> {
  return loadEntityGovernanceRows(accountId);
}
